import { getSelectedSTObj } from './addressUtils';
export const analyticsCache: any = { globalSearchData: {}, pageData: {} }
export function clearDataLayer() {
	const _window: any = window;
	if (_window.digitalData.form) {
		delete _window.digitalData.form;
	}
	_window.digitalData.products.primary = [];
	_window.digitalData.search = {}
	analyticsCache.globalSearchData = {}
	console.log('clearDataLayer products cleared')
}

export const pageDetailsDataPush = (payload: any) => {
	const { type, name } = payload
	const countrycode = 'cn'
	const langCode = 'zh'
	const currencyCode = 'CNY'
	const _window: any = window;
	const obj: any = {
		general: {
			country: {
				name: "China",
				twoLetterCode: "cn",
				threeLetterCode: "chn"
			},
			currencyCode: currencyCode,
			langCode: langCode
		},
		page: {
			type: type,             // [String]
			name: name,          // [String]
			url: window.location.href,  // [String]
			baseUrl: window.location.origin + window.location.pathname, // [String]
			// URL Params will be added here by Adobe Launch utilities script
			// window.utilities.extractURLParams(url); // there is a error thrown if url dont have &
			params: payload.params || {},
			breadcrumbs: payload.breadcrumbs || [], // Array[String]
		}
	}
	// get previous page url
	if (analyticsCache.pageData?.previousPageUrl) {
		// document.dispatchEvent(new CustomEvent("pageload"))
		obj.page.referrer = analyticsCache.pageData.previousPageUrl
		obj.page.previousPage = analyticsCache.pageData.previousPageName
	} else {
		obj.page.referrer = window.document.referrer
		obj.page.previousPage = 'no previous value'
	}
	_window.digitalData.general = obj.general;
	// 1. push data
	console.log('pageloadstep 1. push data to digitalData')
	_window.digitalData.page = obj.page;
	// 2. trigger pageload flow
	if (analyticsCache.pageData?.previousPageUrl) {
		document.dispatchEvent(new CustomEvent("pageload"));
		console.log("========= pageload =========", undefined, _window.digitalData)
	} else {
		// 2. first landing page
		const allCookies = document.cookie
		const isUtilReady = !!_window._satellite
		console.log('isUtilReady', isUtilReady)
		// console.log('allCookies', allCookies)
		const isAAReady = allCookies.split(";").some((item) => item.trim().startsWith("_launch=ready"))
		console.log('isAAReady', isAAReady)
		// if (isUtilReady) {
		// 	console.log('pageloadstep 2. first landing pageload triggered')
		// 	document.dispatchEvent(new CustomEvent("pageload"));
		// } else {
		// }
		// if (isUtilReady && isAAReady) {
		// 	console.log('pageloadstep 2. first landing pageload triggered')
		// 	document.dispatchEvent(new CustomEvent("pageload"));
		// } else {
		// 	analyticsCache.pendingPush = true;
		// 	console.log('pageloadstep to be triggered later')
		// }
		// document.dispatchEvent(new CustomEvent("pageload"));
		// console.log('pageloadstep 2. set firstLPageload true')
		//_window.digitalData.firstLPageload = true
		if (analyticsCache.pendingPush) { // pc cart case.
			console.log('pageloadstep first landing pageload triggered')
			document.dispatchEvent(new CustomEvent("pageload"));
			analyticsCache.pendingPush = false;
		} else {
			analyticsCache.pendingPush = true;
			console.log('pageloadstep first landing pageload to be triggered later')
			setTimeout(() => {
				if (analyticsCache.pendingPush) {
					document.dispatchEvent(new CustomEvent("pageload"));
					analyticsCache.pendingPush = false;
				}
			}, 2000);
		}
	}
	// cache current page url
	analyticsCache.pageData = {
		previousPageUrl: obj.page.url,
		previousPageName: obj.page.name
	}
	console.log("========= digitalData Push =========pagedetails", { ...(_window.digitalData) })
	// if (_window.isAnalyticsFirstHit !== false) {
	// 	_window.isAnalyticsFirstHit = false;
	// } else {
	// 	console.log("========= EVENT DISPATCH ========= pageload",obj)
	// 	document.dispatchEvent(new CustomEvent("pageload"))
	// };
}
export const getAATabName = (tab: any) => {
	const temp = new Map([
		['Product', 'product'],
		['Workflow', 'workflow'],
		['VM Workflow', 'vm workflow'],
		['PROMOTION', 'promotion'],
		['knowledgeHub', 'learning center'], //
		['Application', 'application'],
		['Recent Search', 'recent search'],
		['Hot Search', 'hot search']
	])
	if (!temp.has(tab)) return tab
	return temp.get(tab)

}
export const AAInitUserDetails = (user: any) => {
	const loggedIn = user && !!user.user
	const _window: any = window
	if (!_window.digitalData) {
		_window.digitalData = {
			general: {},
			page: {},
			user: {},
			products: { primary: [], secondary: [], recommended: [], similar: [], related: [] }
		}
	}
	_window.digitalData.user = {
		loginStatus: loggedIn ? 'logged in' : 'anonymous',
		gigyaId: user?.user?.cdcUid || '',
	}
}

export const dispatchEventFunc = (event: any, payload?: any) => {
	const _window: any = window
	if (payload) {
		document.dispatchEvent(new CustomEvent(event, { detail: payload }));
	} else {
		document.dispatchEvent(new CustomEvent(event));
	}
	console.log(`========= ${event} =========`, payload, _window.digitalData)
}
export const getUniqueness = (keyword: any) => {
	let unique = 'no';
	let tempSet = new Set()

	let searchTerms: any = sessionStorage.getItem('searchTerms')
	if (!searchTerms) {
		tempSet.add(keyword)
		unique = 'yes'
	}
	if (searchTerms) {
		tempSet = new Set(JSON.parse(searchTerms))
		if (tempSet.has(keyword)) {
			unique = 'no'
		} else {
			tempSet.add(keyword)
			unique = 'yes'
		}
	}
	sessionStorage.setItem('searchTerms', JSON.stringify(Array.from(tempSet)))
	return unique
}
export const globalSearchDataPush = (payload: any, step?: number) => {
	const _window: any = window
	const { searchType, keyword, eventType, filters, hardCode } = payload
	// step 3
	if (eventType === 'resultClick') {
		const eventPayload = {
			resultPosition: analyticsCache.globalSearchData.searchType
		}
		delete _window.digitalData.search.unique
		setGlobalSearchCache(null)
		dispatchEventFunc('search:resultClick', eventPayload);
		return;
	}
	let unique = ''
	if (searchType && !searchType.startsWith('global search:')) {
		payload.searchType = `global search:${getAATabName(searchType)}`
	}
	if (step == 1) {
		unique = getUniqueness(keyword)
		payload.unique = unique
		setGlobalSearchCache({ ...payload, step: 1 })
		console.log("=== step 1", searchType)
	} else {
		// step 2 could be triggeredd twice?
		console.log('analyticsCache.globalSearchData', { ...(analyticsCache.globalSearchData) })
		if (analyticsCache.globalSearchData.step == 2) {
			return;
		}
		if (!hardCode) {
			console.log('page details result')
			pageDetailsDataPush({
				"type": 'search',
				"name": 'search results',
			})
		}
		analyticsCache.globalSearchData.step = 2
	}
	const obj = {
		...payload
	}
	delete obj.eventType
	delete obj.hardCode
	_window.digitalData.search = obj
	console.log("========= digitalData Push =========globalSearch", obj, step)
	const eventName = `search:${eventType}`
	dispatchEventFunc(eventName);
}
export const setGlobalSearchCache = (payload: any, step?: number) => {
	if (step == 1) {
		payload.unique = getUniqueness(payload.keyword)
		payload.step = 1
		console.log('setGlobalSearchCache', payload)
	}
	analyticsCache.globalSearchData = { ...payload }
}
export const getGlobalSearchCache = (currentKeyword: any) => {
	const noUniqueKeyTypes = ['hot search']
	const useCacheKeywordTypes = ['hot search', 'recent search', 'suggestion'];
	const tempSearchType = analyticsCache.globalSearchData?.searchType;
	if (!tempSearchType) return null;
	const noUniqueKey = tempSearchType.includes(noUniqueKeyTypes[0])
	const useCacheKeyword = useCacheKeywordTypes.filter((item) => {
		return tempSearchType.includes(item)
	})
	const keyword = useCacheKeyword ? analyticsCache.globalSearchData.keyword : currentKeyword;

	const res: any = {
		searchType: tempSearchType,
		keyword
	}
	if (!noUniqueKey) res.unique = analyticsCache.globalSearchData.unique
	const filters = analyticsCache.globalSearchData.filters
	if (filters) {
		res.filters = filters
	}
	const suggestionWord = analyticsCache.globalSearchData.suggestedKeyword
	if (suggestionWord) {
		res.suggestedKeyword = suggestionWord
	}
	return res;
}
const triggerPageLoad = () => {
	if (analyticsCache.pendingPush) {
		console.log('pageloadstep first landing pageload triggered')
		document.dispatchEvent(new CustomEvent("pageload"));
		analyticsCache.pendingPush = false;
		return;
	}
}
export const subSearchDataPush = (payload: any) => {
	triggerPageLoad();
	const _window: any = window
	let eventPayload = null
	if (payload.eventType === 'search:resultClick') {
		eventPayload = {
			resultPosition: payload.resultPosition
		}
		delete _window.digitalData.search.unique
	} else {
		_window.digitalData.search = payload
	}
	dispatchEventFunc(payload.eventType, eventPayload)
}

export const formatProductImpressionInfo = (product: any) => {
	return {
		name: product?.productTitle,
		catalogId: product?.catalogNumber,
		variant: product?.variant,
		price: product?.price
	};
};

// view Content,collect products first
export const viewContentDataPush = (payload: any) => {
	const { type = "", placement = "", products = [] } = payload;
	if (type.includes('products') && !products?.length) return;
	products.forEach((product: any) => {
		if (!product) return;
		let tempPrice = product?.price
		if (typeof tempPrice === 'string') {
			tempPrice = tempPrice.replace(/\,/g, '')
		}
		product.price = tempPrice ? Number(tempPrice).toFixed(2) : '0'
	});
	const _window: any = window
	// check placement is safe
	// if (placement && placement.startsWith('__proto__')) {
	// 	console.log('placement is dangerous', placement)
	// 	return;
	// }
	let detailObj: any = {
		type,
		placement,
	}
	let pts = Object.create(null);
	pts[placement] = products;
	detailObj.products = pts;
	document.dispatchEvent(
		new CustomEvent("viewContent", {
			detail: detailObj
		})
	)
	console.log("========= viewContent =========", detailObj, _window.digitalData)
}

export const productClickDataPush = (payload: any) => {
	const { placement = "", products = [] } = payload;
	const product = products[0]
	if (!product) return;
	if (!product.catalogId) return;
	let tempPrice = product?.price
	if (typeof tempPrice === 'string') {
		tempPrice = tempPrice.replace(/\,/g, '')
	}
	product.price = tempPrice ? Number(tempPrice).toFixed(2) : '0'
	// if (placement && placement.startsWith('__proto__')) {
	// 	console.log('placement is dangerous', placement)
	// 	return;
	// }
	const _window: any = window
	const dispatchObj: any = {
		placement
	};
	let pts = Object.create(null);
	pts[placement] = products;

	dispatchObj.products = pts;
	document.dispatchEvent(
		new CustomEvent("productClick", {
			detail: dispatchObj,
		})
	);
	console.log("========= productClick =========", dispatchObj, _window.digitalData)
};

export const productDetailsTracking = (product: any) => {
	const _window: any = window
	let tempPrice = product.price
	if (typeof tempPrice === 'string') {
		tempPrice = tempPrice.replace(/\,/g, '')
	}
	product.price = tempPrice ? Number(tempPrice).toFixed(2) : '0'
	document.dispatchEvent(new CustomEvent("prodView", { detail: { product } }));
	console.log("========= prodView =========", product, _window.digitalData);
};
export function getSubTotal(update: any, currentAddedProducts: any) {
	let total = 0;
	let products: any[] = []
	if (update.data) {
		update.data?.cartItems?.map((item: any) => {
			let tempPrice = item.finalPrice
			if (currentAddedProducts && (!tempPrice || tempPrice === '0')) {
				// getPrice form currentAddedProducts
				const targetProduct = currentAddedProducts.find((currentAddedProduct: any) => {
					return currentAddedProduct.catalogId === item.catalogNumber
				})
				if (targetProduct && targetProduct.price) {
					tempPrice = Number(targetProduct.price)
				}
			}
			tempPrice = tempPrice ? (tempPrice * item.quantity) : 0
			products.push({
				catalogId: item.catalogNumber,
				quantity: item.quantity,
				price: tempPrice ? tempPrice.toFixed(2) : "0"
			})
			total = total + tempPrice
		})
	}
	if (update.cartItems) {
		update.cartItems.map((item: any) => {
			let tempPrice = item.finalPrice
			if ((!tempPrice || tempPrice === '0') && currentAddedProducts) {
				// getPrice form currentAddedProducts
				const targetProduct = currentAddedProducts.find((currentAddedProduct: any) => {
					return currentAddedProduct.catalogId === item.catalogNumber
				})
				if (targetProduct && targetProduct.price) {
					tempPrice = Number(targetProduct.price)
				}
			}
			tempPrice = tempPrice ? (tempPrice * item.quantity) : 0
			products.push({
				catalogId: item.catalogNumber,
				quantity: item.quantity,
				price: tempPrice ? tempPrice.toFixed(2) : "0"
			})
			total = total + tempPrice
		})
	}
	return {
		subtotal: total.toFixed(2),
		products
	}
}
export const cartTrackingDataPush = (payload: any) => {
	triggerPageLoad();
	const { actionType, cartId, dispatchObj, currentCartData } = payload
	const _window: any = window
	const temp = dispatchObj.products?.length
	if (!temp) return;
	// const { subtotal, products } = getSubTotal(currentCartData, dispatchObj.products)
	// _window.digitalData.cart = {
	// 	id: cartId,
	// 	subtotal,
	// 	products,
	// 	currencyCode: 'CNY'
	// }
	if (actionType === 'add') {
		const { placement, products } = dispatchObj
		// if (placement && placement.startsWith('__proto__')) {
		// 	console.log('placement is dangerous', placement)
		// 	return;
		// }
		let pts = Object.create(null);
		pts[placement] = products;
		dispatchObj['products'] = pts
		document.dispatchEvent(new CustomEvent("addToCart", { detail: dispatchObj }))
		console.log('========= addToCart =========', dispatchObj, _window.digitalData)
	}
	if (actionType === 'remove') {
		document.dispatchEvent(new CustomEvent("cartRemove", { detail: dispatchObj }))
		console.log('========= cartRemove =========', dispatchObj, _window.digitalData)
	}
}
const updateCartDatalayerMycart = (payload: any, currentAddedProducts: any, refreshCartData?: any) => {
	console.log('updateCartDatalayer')
	if (!payload) return;
	const { currentCartData, cartId = "" } = payload;
	const _window: any = window
	const isCartEmpty = !_window.digitalData.cart?.products || !_window.digitalData.cart?.products.length
	const { subtotal, products } = getSubTotal(currentCartData, currentAddedProducts)
	const cartObj = {
		id: cartId,
		// products,
		// subtotal,
		currencyCode: "CNY"
	}
	_window.digitalData.cart = cartObj
	if (currentCartData.isFirstCart || currentCartData.data.isFirstCart) {
		dispatchEventFunc('cartCreated', { id: cartId, products })
	}
	const isNewCartID = localStorage.getItem('IS_NEW_CART_ID');
	console.log('anonymous user: isNewCartID', isNewCartID, isCartEmpty, _window.digitalData?.user?.loginStatus)
	if (isNewCartID === 'true' && isCartEmpty && _window.digitalData?.user?.loginStatus === "anonymous") {
		dispatchEventFunc('cartCreated', { id: cartId, products })
		localStorage.setItem('IS_NEW_CART_ID', "false")
	}
}
const updateCartDatalayer = (payload: any, currentAddedProducts: any, refreshCartData?: any) => {
	if (!payload) return;
	const { currentCartData, cartId = "" } = payload;
	const _window: any = window
	const cartObj = {
		id: cartId,
		// products,
		// subtotal,
		currencyCode: "CNY"
	}
	_window.digitalData.cart = cartObj
}
export const addToCartDataPush = async (payload: any) => {
	triggerPageLoad();
	const { cartObj, placement = "", method = "", products = [] } = payload;
	if (!products.length) return;
	// const refreshCartData = await commonUpdateCart(user, cartObj.cartId);
	if (!placement) {
		console.log('addtocart event has undefined placement value current page', window.location.href)
	}
	// if (placement && placement.startsWith('__proto__')) {
	// 	console.log('placement is dangerous', placement)
	// 	return;
	// }
	if (!products.length) return;
	updateCartDatalayer(cartObj, products)
	const _window: any = window
	const dispatchObj: any = {
		placement,
		method,
	};
	let pts = Object.create(null);
	pts[placement] = products;
	dispatchObj['products'] = pts;
	document.dispatchEvent(
		new CustomEvent("addToCart", {
			detail: dispatchObj,
		})
	);
	console.log("========= addToCart =========", dispatchObj, _window.digitalData)
};

export const wishListTrackingDataPush = ({ actionType, payload }: { actionType: string, payload: any }) => {
	const { contentType, contentData, price, contentId, contentTitle } = payload
	console.log('contentData', contentData)
	const _window: any = window
	const wishlistType = contentType === "Products" ? "product" : 'content';
	const analyticsData: any = {
		contentType: contentType,
		itemDetail: contentTitle,
	}
	if (wishlistType === 'product') {
		const tempPrice = price?.formattedPrice || price || ''
		let finalPrice = tempPrice.finalPrice || tempPrice.yourPrice || tempPrice.listPrice || tempPrice || ''
		if (typeof finalPrice === 'string') {
			finalPrice = finalPrice.replace(/\,/g, '')
		}
		const name = contentData?.title || contentData?.productTitle || contentData?.productName || contentData?.description
		analyticsData.itemDetail = contentId
		analyticsData.products = [{
			name,
			catalogId: contentId,
			price: finalPrice ? Number(finalPrice).toFixed(2) : '0'
		}]
	}
	if (actionType == 'add') {
		document.dispatchEvent(new CustomEvent("addToWishlist", { detail: analyticsData }))
		console.log("========= addToWishlist =========", analyticsData, _window.digitalData)
	}
	if (actionType == 'remove') {
		document.dispatchEvent(new CustomEvent("removeFromWishlist", { detail: analyticsData }))
		console.log("========= removeFromWishlist =========", analyticsData, _window.digitalData)
	}
}
export const offersDataPush = (payload: { type: 'offerCopied' | "offerApplied", code: string }) => {
	const { type = "", code = '' } = payload;
	const _window: any = window
	document.dispatchEvent(
		new CustomEvent(type, {
			detail: {
				code
			},
		})
	);
	console.log(`========= ${type} =========`, code, _window.digitalData)
}

export const documentEngagementDataPush = (type: string, name: string) => {
	const _window: any = window
	const dispatchObj = { type, name };
	document.dispatchEvent(new CustomEvent("documentEngagement", { detail: dispatchObj }));
	console.log('========= documentEngagement =========', dispatchObj, _window.digitalData);
};

export const personaDataPush = (payload: any) => {
	const { question, answers } = payload
	const _window: any = window
	document.dispatchEvent(new CustomEvent("persona:update", { detail: payload }));
	console.log('========= persona:update =========', payload, _window.digitalData)
}

export const purchaseDataPush = (payload: any) => {
	const _window: any = window
	const { orderData, eventData } = payload
	_window.digitalData.order = [orderData]
	console.log('========= digitalData Push =========', _window.digitalData)
	document.dispatchEvent(new CustomEvent("orderConfirmed", {
		detail: eventData
	}))
	console.log('========= orderConfirmed =========', eventData, _window.digitalData)
}

export const updatePdetailsInCart = (productDetails: any) => {
	if (!productDetails) return
	const _window: any = window
	const products = _window.digitalData?.cart?.products
	if (products && products.length) {
		const target = products.find((item: any) => item.catalogId === productDetails.catalogNumber)
		if (target) {
			target.name = productDetails.productTitle
		}
	}
}

export const updateCartAnalytics = (cartData: any, ordersubmited?: any) => {
	console.log('updateCartAnalytics', cartData)
	const { products, subtotal } = getSubTotal(cartData, null);
	const target = products.find((item: any) => {
		return (!item.price || item.price === '0')
	})
	let payload: any = {
		id: cartData.cartId,
		products,
		subtotal,
		currencyCode: 'CNY'
	}
	if (target) {
		return;
	}
	const _window: any = window
	_window.digitalData.cart = payload
	if ((ordersubmited === 'true' && products?.length) || ordersubmited === 'triggerCartCreated') {
		dispatchEventFunc('cartCreated', { id: cartData.cartId, products })
		localStorage.setItem('orderSubmitted', 'false')
	}
}

// export const commonUpdateCart = async (user: any, cartId: any) => {
// 	const updateCartUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/cart/updateCart`;
// 	const updateCartNotLoggedInUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/unsignedCart/updateCart`;
// 	const token = "";
// 	const address = getSelectedSTObj(user);
// 	const addressKey = address.shipToAddress
// 		? address.shipToAddress.addressKey
// 		: null;
// 	const prePaymentAccount = address.prePaymentAccount;
// 	const orderShipTo = address.shipToAddress
// 		? address.shipToAddress.accountNumber
// 		: null;
// 	let requestBody = {
// 		action: 'REFRESH',
// 		addressKey,
// 		orderShipTo,
// 		cartId: cartId,
// 		siebelRowId: null,
// 		payload: null,
// 		userId: user && user.info ? user.info.userId : null,
// 		userName: user && user.info ? user.info.userName : null,
// 		prePaymentAccount,
// 	};
// 	const headers = token ? {
// 		'Content-Type': 'application/json',
// 		Authorization: token,
// 		countrycode: user.country,
// 		languagecode: user.language,
// 	} : {
// 		'Content-Type': 'application/json',
// 		countrycode: user.country,
// 		languagecode: user.language,
// 	};
// 	const url = token ? updateCartUrl : updateCartNotLoggedInUrl;
// 	return axios.post(url, requestBody, { headers })
// 		.then(async (data) => {
// 			return data;
// 		}).catch((err) => {
// 			console.log("error while fetching cart details is: ", err);
// 			return Promise.reject(err);
// 		})
// }

export const updateCartAADatalayer = (cartData: any, priceMap: any, productsDetail: any) => {
	cartData.cartItems = cartData.cartItems?.map((item: any) => {
		//const targetDetail = productsDetail?.find(detailItem => detailItem.catalogNumber === item.catalogNumber)
		return {
			catalogNumber: item.catalogNumber,
			finalPrice: priceMap?.get(item.catalogNumber)?.finalPrice,
			quantity: item.quantity
		}
	})
	const { products, subtotal } = getSubTotal(cartData, null);
	const _window: any = window

	let payload: any = {
		id: cartData.cartId,
		products,
		subtotal,
		currencyCode: 'CNY'
	}
	console.log('updateCartAADatalayer', payload)
	_window.digitalData.cart = payload
}


export const getSQProductList = (sQuoteItemSelected: any, sQuoteItemData: any) => {
	if (sQuoteItemSelected && sQuoteItemData) {
		let cartId = null
		const sQProductList = sQuoteItemData?.orderLineList.map((sQItem: any) => {
			return {
				name: sQItem.productTitle || sQItem.itemName,
				catalogId: sQItem.sku,
				quantity: sQItem.desiredQty,
				price: sQItem.unitPrice ? (sQItem.desiredQty * sQItem.unitPrice).toFixed(2) : "0"
			}
		})
		return sQProductList
	}
	return null
}

export const searchMilestoneCategoryAnalytics = (payload: any) => {
	const _window: any = window
	const { eventData } = payload
	_window.digitalData.search = payload
	console.log('========= search milestone category  =========', _window.digitalData)
	document.dispatchEvent(new CustomEvent("search:filtered"));
}
